import FadeIn from '../../../components/animation/fadeIn';
import Category from '../../../components/category/category';
import { cheetah } from '../../../constants/cheetah';

export default function Cheetah() {
    return (
        <section id="Cheetah">
            <Category>Cheetah!</Category>
            {cheetah.map((val, i) => (
                <p key={ i } className="article-information">{val}</p>
            ))}
            <FadeIn animateFrom={{ y: '300', opacity: '0' }} animateTo={{ y: '0', opacity: '1' }} onView={ true } rootMargin='10px' threshold={ 0.1 } delay={ 100 } transitionDuration={ 800 } className='gallery'>
                <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cheetah/1.jpg)` }} className='img-1'/>
                <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cheetah/2.jpg)` }} className='img-2'/>
                <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cheetah/3.jpg)` }} className='img-3'/>
                <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cheetah/4.jpg)` }} className='img-4'/>
                <div style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/cheetah/5.jpg)` }} className='img-5'/>
            </FadeIn>
        </section>
    );
};